export const barChart = {
    series: [{
        data: [],
        name: "Number of vehicles",
        color: "#78BE20",
    }],
    chartOptions: {
        chart: {
            type: 'bar',
            height: 350,
            zoom: {
                enabled: false,
            },
            background: "#0D3937",  // set to dark: allow clear to display in export png
            toolbar: {
                show: true,
                tools: {
                  // replace default dropdown icons with custom ones:
                  download: false,
                },
              },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 1, // bar corner radius to 1: original design is 1
                columnWidth: '55%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            title: {
                text: "Manufacture Year",
                style: {
                    color: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: 700,
                    fontFamily: "Moderat",
                },
            },
            labels: {
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Moderat",
                    fontWeight: 400,
                },
            },
            categories: [],
        },
        yaxis: [{
                decimalsInFloat: 0,
                tickAmount: 5,
                tickPlacement: "between",
                title: {
                    text: "Number of Vehicles",
                    style: {
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 700,
                        fontFamily: "Moderat",
                    },
                },
                labels: {
                    style: {
                        colors: "#FFFFFF",
                        fontSize: "12px",
                        fontFamily: "Moderat",
                        fontWeight: 400,
                    },
                },
                axisBorder: {
                    show: false,
                    color: "#FFFFFF",
                },
                axisTicks: {
                    show: false,
                    color: "#FFFFFF",
                },
            },
        ],
        legend: {
            position: "top",
            labels: {
                colors: "#FFFFFF",
            },
            markers: {
                fillColors: ["#78BE20", "#DDF0AC"],
            },
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: [{
                    formatter: function(val) {
                        return val
                    }
                },
            ]
        }
    },
}

export const pieChart = {
    series: [],
    chartOptions: {
        chart: {
            type: 'pie',
            height: 350,
            background: "#0D3937",
            toolbar: {
                show: true,
                tools: {
                    download: false,
                },
            },
        },
        labels: [],
        colors: ["#78BE20", "#DDF0AC", "#4A9B8E", "#2D5A4A", "#1A3D33"],
        dataLabels: {
            enabled: true,
            style: {
                colors: ["#FFFFFF"],
                fontSize: "12px",
                fontFamily: "Moderat",
                fontWeight: 400,
            },
            formatter: function (val) {
                return val.toFixed(1) + "%";
            }
        },
        legend: {
            position: "bottom",
            labels: {
                colors: "#FFFFFF",
                useSeriesColors: false,
            },
            markers: {
                fillColors: ["#78BE20", "#DDF0AC", "#4A9B8E", "#2D5A4A", "#1A3D33"],
            },
        },
        tooltip: {
            fillSeriesColor: false,
            theme: 'dark',
            style: {
                fontSize: '12px',
                fontFamily: 'Moderat',
            },
            y: {
                formatter: function (val) {
                    return val + " vehicles";
                }
            }
        },
        plotOptions: {
            pie: {
                expandOnClick: true,
                donut: {
                    size: '0%'
                }
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: "bottom"
                }
            }
        }]
    },
}

export const plotBoxChart = {
    series: [{
        data: [],
        name: "Charger Capacity",
        color: "#78BE20",
    }],
    chartOptions: {
        chart: {
            type: 'boxPlot',
            height: 150,
            background: "#0D3937",
            toolbar: {
                show: true,
                tools: {
                    download: false,
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '40%'
            },
            boxPlot: {
                whiskerLength: 15,
                horizontal: true,
            },
        },
        colors: ["#78BE20"],
        dataLabels: {
            enabled: false,
        },
        stroke: {
            colors: ["#78BE20"],
            width: 2,
        },
        fill: {
            colors: ["#78BE20"],
            opacity: 0.8,
        },
        xaxis: {
            categories: [],
            labels: {
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Moderat",
                    fontWeight: 400,
                },
            },
            axisBorder: {
                show: false,
                color: "#FFFFFF",
            },
            axisTicks: {
                show: false,
                color: "#FFFFFF",
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: "#FFFFFF",
                    fontSize: "12px",
                    fontFamily: "Moderat",
                    fontWeight: 400,
                },
            },
            axisBorder: {
                show: false,
                color: "#FFFFFF",
            },
            axisTicks: {
                show: false,
                color: "#FFFFFF",
            },
        },
        tooltip: {
            theme: 'dark',
            style: {
                fontSize: '12px',
                fontFamily: 'Moderat',
            },
            y: {
                formatter: function (val) {
                    return val + " kWh";
                }
            }
        },
        grid: {
            borderColor: "#DDF0AC",
            strokeDashArray: 3,
        },
    },
}
